export default __webpack_public_path__ + "static/media/1906.e401584b.png";